const isEmpty = (prop) =>
  prop === null ||
  prop === undefined ||
  (prop.hasOwnProperty('length') && prop.length === 0) ||
  (prop.constructor === Object && Object.keys(prop).length === 0);

export default isEmpty;



// WEBPACK FOOTER //
// ./src/common/lib/IsEmpty.js